import * as React from 'react';
import { Drawer } from '@mui/material';
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  ListItemSecondaryAction
} from '@mui/material';
import {withStyles,
  WithStyles,
  StyleRules
} from '@mui/styles';
import { Icon } from '@mui/material';
import { Switch } from '@mui/material';
import { Divider } from '@mui/material';

import { Theme } from '@mui/styles';

import PortalUserContext, { FeatureArea} from '~common/lib/portal-user-context'


// import { each, sortBy } from 'lodash';

export interface MenuDrawerProps extends React.HTMLProps<HTMLDivElement> {
  open: boolean;
  history: any;
  onClose?: Function;
  invertToolbar?: boolean;
}

const styles = (theme: Theme): StyleRules => ({
  drawerWidth: {
    width: 300
  },
  icon: {
    fontSize: 20,
    marginRight: 5,
    color: theme.palette.primary.main + " !important",
    minWidth: "35px !important"
  },
  faicon: {
    fontSize: 20,
    marginRight: 5,
    color: theme.palette.primary.main + " !important",
    minWidth: "35px !important"
  },
  subHeader: {
    marginLeft: 30
  },
  menuItem: {
    fontSize: theme.typography.body1.fontSize,
    fontWeight: 500
  },
  menuItemDescription: {
    color: theme.palette.grey['600'],
    fontSize: '0.95rem',
    fontWeight: 400
  },
  featureArea: {
    cursor: "pointer",
  }
});

type State = {
  drawerOpen: boolean;
  showVerboseMenus?: boolean;
  featureAreaVisibility: any;
};

class MenuDrawer extends React.Component<
  MenuDrawerProps & WithStyles<keyof typeof styles>,
  State
  > {
  constructor(props: MenuDrawerProps & WithStyles<keyof typeof styles>) {
    super(props, {});
    // Check for menu collaps cookie

    var menuState:any = {}
    if (PortalUserContext.userContext.extendedAttributes.retainMenuCollapse){
      menuState = this.getFeatureAreaVisibilityCookie()
    }

    // Attention: Using preferences
    const newState = {
      drawerOpen: false,
      featureAreaVisibility: menuState,
    };

    this.state = newState;
  }

  setFeatureAreaVisibilityCookie = (data: any) => {
    document.cookie = "featureAreaVisibility=" + JSON.stringify(data) + ";path=/";
  }

  getFeatureAreaVisibilityCookie = () => {
    try {
      var name = "featureAreaVisibility=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          const cookieData = JSON.parse(c.substring(name.length, c.length));
          return cookieData;
        }
      }
    } catch {
      // Cleanup the cookie if it cannot be parsed
      document.cookie = "featureAreaVisibility=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      return {}
    }
    return {}
  }

  UNSAFE_componentWillReceiveProps(
    newProps: MenuDrawerProps & WithStyles<keyof typeof styles>
  ) {
    const uc = PortalUserContext.userContext;

    var verbose: boolean | undefined;

    if (this.state.showVerboseMenus == undefined) {
      verbose = uc.extendedAttributes.showVerboseMenus
        ? uc.extendedAttributes.showVerboseMenus
        : undefined;
    } else {
      verbose = this.state.showVerboseMenus;
    }

    this.setState({ drawerOpen: newProps.open, showVerboseMenus: verbose });
  }

  toggleDrawer = (open: boolean) => () => {
    this.setState({
      drawerOpen: open
    });

    if (this.props.onClose && !open) {
      this.props.onClose();
    }
  };

  toggleCompact = () => {
    this.setState({
      showVerboseMenus: !this.state.showVerboseMenus
    });
  };

  handleMenuItemClick = (url: string) => () => {
    window.location.href = url;
  };

  render() {
    const { drawerOpen } = this.state;
    const { classes } = this.props;

    const featureAreas = PortalUserContext.featureAreas;

    var sidx = 0;
    var menuListItems: any = null;
    if (featureAreas) {
      menuListItems = featureAreas.map((fa: FeatureArea, idx: number) => {
        var listIcon: any;
        var inset: boolean = true;

        var subAreas: any = {};

        fa.features.forEach((f) => {
          if (f.extendedAttributes && f.extendedAttributes.url) {
            var key = f.subAreaTitle ? f.subAreaTitle : 'none';
            if (!subAreas[key]) {
              subAreas[key] = {
                title: f.subAreaTitle,
                features: new Array<any>()
              };
            }

            subAreas[key].features.push(f);
          }
        });

        if (fa.extendedAttributes && fa.extendedAttributes.icon) {
          if (fa.extendedAttributes.icon.indexOf("fa-") > -1) {
            listIcon = (
              <ListItemIcon color="primary" className={classes['icon']}>
                <i className={classes['faicon'] + ' fa ' + fa.extendedAttributes.icon} />
              </ListItemIcon>
            );
          } else if (fa.extendedAttributes.icon) {
            listIcon = (
              <ListItemIcon color="primary"  className={classes['icon']}>
                <Icon>{fa.extendedAttributes.icon}</Icon>
              </ListItemIcon>
            );
          }

          inset = false;
        }

        let sal = new Array<any>();
        for (let key in subAreas) {
          sidx += 1;
          var sa = subAreas[key];
          var fidx = 0;
          let fl = sa.features.map((f: any, idx: number) => {
            fidx += 1;

            if (!f.extendedAttributes) {
              return null;
            }

            return (
              <ListItem
                key={'f' + fidx}
                className={f.key}
                button
                onClick={this.handleMenuItemClick(f.extendedAttributes.url)}>
                <ListItemText
                  disableTypography
                  className={classes['menuItem']}
                  inset
                  primary={<div className={classes['menuItem']}>{f.title}</div>}
                  secondary={
                    <div className={classes['menuItemDescription']}>
                      {this.state.showVerboseMenus ? f.description : null}
                    </div>
                  }
                />
              </ListItem>
            );
          });

          var subheader: any;
          if (sa.title) {
            subheader = (
              <ListSubheader className={classes['subHeader']}>
                {sa.title}
              </ListSubheader>
            );
          }

          sal.push(
            <List dense key={'sa' + sidx} subheader={subheader}>
              {fl}
            </List>
          );
        }

        if (sal.length == 0) {
          return null;
        }

        let button = false;
        let onClick: any;
        if (fa.extendedAttributes && fa.extendedAttributes.url) {
          onClick = this.handleMenuItemClick(fa.extendedAttributes.url);
        }

        return (
          <div key={'fa' + idx}>
            <ListItem button={button} onClick={onClick}>
              {listIcon}
              <ListItemText className={classes['featureArea']} onClick={() => {
                var { featureAreaVisibility } = this.state;
                featureAreaVisibility[fa.title] = !featureAreaVisibility[fa.title]
                this.setState({
                  featureAreaVisibility: featureAreaVisibility
                }, () => {
                  this.setFeatureAreaVisibilityCookie(featureAreaVisibility)
                })

              }} inset={inset} primary={fa.title} />
            </ListItem>
            <div key={'fal-' + fa.title} style={{ display: this.state.featureAreaVisibility[fa.title] == true ? 'none' : '' }}>
              {sal}
            </div>
          </div>
        );
      });
    }

    return (
      <div>
        <Drawer
          className="menu-drawer"
          open={drawerOpen}
          onClose={this.toggleDrawer(false)}
        >
          <div tabIndex={0} role="button">
            <div className={classes['drawerWidth']}>
              <List data-name="icg-menu" id={"icg-menu"}>
                <ListItem button onClick={this.handleMenuItemClick('/')}>
                  <ListItemIcon className={classes['icon']}>
                    <Icon>home</Icon>
                  </ListItemIcon>
                  <ListItemText primary="Home" />
                </ListItem>
                {menuListItems}
                <Divider />
                <ListItem>
                  <ListItemText primary="Verbose" />
                  <ListItemSecondaryAction>
                    <Switch
                      onChange={this.toggleCompact}
                      checked={this.state.showVerboseMenus}
                      color="secondary"
                    />
                  </ListItemSecondaryAction>
                </ListItem>
              </List>
            </div>
          </div>
        </Drawer>
      </div>
    );
  }
}

export default withStyles(styles)(MenuDrawer);
